import { Component, ViewChild, TemplateRef, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
import { Proyecto } from "src/app/models/proyecto.model";
declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-proyecto",
    templateUrl: "./proyecto.component.html",
    styleUrls: ["./proyecto.component.css"],
    providers: [FormService]
})

export class ProyectoComponent implements OnInit {
    @ViewChild('openModal') openModal: TemplateRef<any>;
    @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;
    @ViewChild('openModalNOVALID') openModalNOVALID: TemplateRef<any>;
    public rows = [];
    public actualRow;
    public proyecto: Proyecto;
    public form;
    public temp_proy;
    public autorizacion = { "Art121": false, "Art122": false, "Art123": false, "Art124": false, "Ley19537": false, "Otro": false }
    public matcher = new FormService();
    public n_form
    constructor(private fb: FormBuilder, private dialog: MatDialog) {


        this.form = new FormGroup({
            destinos: new FormControl(''),
            superf_existente: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            superf_proyectada: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            npisos: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            superf_terreno: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            coef_construct: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            ocupadoc: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            ocupadooc: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            proyectadoc: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            coef_ocupacion: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            proyectadooc: new FormControl('',[Validators.min(0),Validators.pattern(/[0-9]*/)]),
            autorizacion1: new FormControl(''),
            autorizacion2: new FormControl(''),
            autorizacion3: new FormControl(''),
            autorizacion4: new FormControl(''),
            autorizacion5: new FormControl(''),
            autorizacion6: new FormControl(''),
            uso_publico: new FormControl(''),
            edif_nac: new FormControl('')
        })

        if (!JSON.parse(localStorage.getItem("proyecto"))) {
            localStorage.setItem("proyecto", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("proyecto"));
            // console.log('proyecto.component.ts this.rows', this.rows[0]);
            // console.log('this.rows[0].Art121: '+ this.rows[0].Art121 + 'this.rows[0].Art122: '+ this.rows[0].Art122 +'this.rows[0].Art123: '+ this.rows[0].Art123 +'this.rows[0].Ley19537: '+ this.rows[0].Ley19537 +'this.rows[0].Otro: '+ this.rows[0].Otro)
            
            // this.form.controls['autorizacion1'].setValue(this.rows[this.rows.length-1] /*existe*/? this.rows[this.rows.length-1].Art121 : false);
            // this.form.controls['autorizacion2'].setValue(this.rows[this.rows.length-1] ? this.rows[this.rows.length-1].Art122 : false);
            // this.form.controls['autorizacion3'].setValue(this.rows[this.rows.length-1] ? this.rows[this.rows.length-1].Art123 : false);
            // this.form.controls['autorizacion4'].setValue(this.rows[this.rows.length-1] ? this.rows[this.rows.length-1].Art124 : false);
            // this.form.controls['autorizacion5'].setValue(this.rows[this.rows.length-1] ? this.rows[this.rows.length-1].Ley19537 : false);
            // this.form.controls['autorizacion6'].setValue(this.rows[this.rows.length-1] ? this.rows[this.rows.length-1].Otro : false);

        }
        this.proyecto = { destinos: '', superf_existente: '', superf_proyectada: '', npisos: '', superf_terreno: '', coef_construct: '', ocupadooc: '', proyectadooc: '', Art121: '', Art122: '', Art123: '', Art124: '', Ley19537: '', Otro: '', uso_publico: '', edif_nac: '' };
        this.temp_proy = { destinos: '', superf_existente: '', superf_proyectada: '', npisos: '', superf_terreno: '', coef_construct: '', ocupadooc: '', proyectadooc: '', Art121: '', Art122: '', Art123: '', Art124: '', Ley19537: '', Otro: '', uso_publico: '', edif_nac: '' };

    }

    ngOnInit() {
        console.log(localStorage.getItem('form'));
        this.n_form = localStorage.getItem('form');
        console.log("Formulario seleccionado", this.n_form)
    }

    add_proyecto() {

        this.actualRow = localStorage.getItem("proyecto");
        this.rows = JSON.parse(this.actualRow);

        if (!this.form.value.destinos && !this.form.value.superf_existente && !this.form.value.superf_proyectada && !this.form.value.superf_terreno
            && !this.form.value.npisos && !this.form.value.coef_construct && !this.form.value.ocupadoc && !this.form.value.proyectadoc
            && !this.form.value.autorizacion1 && !this.form.value.autorizacion2 && !this.form.value.autorizacion3 && !this.form.value.autorizacion4
            && !this.form.value.autorizacion5 && !this.form.value.autorizacion6 && !this.form.value.uso_publico && !this.form.value.edif_nac) {
            console.log("no ingresó ningun campo");
            this.dialog.open(this.openModalNODATA);

        } else if (this.form.controls['superf_existente'].hasError('pattern') || this.form.controls['superf_proyectada'].hasError('pattern')||  this.form.controls['npisos'].hasError('pattern')|| this.form.controls['superf_terreno'].hasError('pattern') || this.form.controls['coef_construct'].hasError('pattern') || this.form.controls['ocupadoc'].hasError('pattern') || this.form.controls['ocupadooc'].hasError('pattern')  || this.form.controls['proyectadoc'].hasError('pattern')  || this.form.controls['coef_ocupacion'].hasError('pattern') || this.form.controls['proyectadooc'].hasError('pattern') ){
            this.dialog.open(this.openModalNOVALID);           
        } else {

            this.rows = this.rows.concat({
                destinos: this.form.value.destinos,
                superf_existente: this.form.value.superf_existente,
                superf_proyectada: this.form.value.superf_proyectada,
                superf_terreno: this.form.value.superf_terreno,
                npisos: this.form.value.npisos,
                coef_construct: this.form.value.coef_construct,
                ocupadoc: this.form.value.ocupadoc,
                proyectadoc: this.form.value.proyectadoc,
                coef_ocupacion: this.form.value.coef_ocupacion,
                ocupadooc: this.form.value.ocupadooc,
                proyectadooc: this.form.value.proyectadooc,
                Art121: this.form.value.autorizacion1,
                Art122: this.form.value.autorizacion2,
                Art123: this.form.value.autorizacion3,
                Art124: this.form.value.autorizacion4,
                Ley19537: this.form.value.autorizacion5,
                Otro: this.form.value.autorizacion6,
                uso_publico: this.form.value.uso_publico,
                edif_nac: this.form.value.edif_nac

            })

            console.log('this.rows',this.rows)

            localStorage.setItem("proyecto", JSON.stringify(this.rows));
            this.form.reset();
        }
    }
    
    delete_proyecto(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("proyecto", JSON.stringify(this.rows));
            }
        }
        this.actualRow = localStorage.getItem("proyecto");
        this.rows = JSON.parse(this.actualRow);
    }

    get_proyecto(id) {
        console.log(id)
        for (let x = 0; x < this.rows.length; x++) {

            if (id == x) {
                this.temp_proy.id = id;
                this.temp_proy.destinos = this.rows[x].destinos;
                this.temp_proy.superf_existente = this.rows[x].superf_existente;
                this.temp_proy.superf_proyectada = this.rows[x].superf_proyectada;
                this.temp_proy.npisos = this.rows[x].npisos;
                this.temp_proy.superf_terreno = this.rows[x].superf_terreno;
                this.temp_proy.coef_construct = this.rows[x].coef_construct;
                this.temp_proy.ocupadoc = this.rows[x].ocupadoc;
                this.temp_proy.proyectadoc = this.rows[x].proyectadoc;
                this.temp_proy.coef_ocupacion = this.rows[x].coef_ocupacion;
                this.temp_proy.ocupadooc = this.rows[x].ocupadooc;
                this.temp_proy.proyectadooc = this.rows[x].proyectadooc;
                this.temp_proy.Art121 = this.rows[x].Art121;
                this.temp_proy.Art122 = this.rows[x].Art122;
                this.temp_proy.Art123 = this.rows[x].Art123;
                this.temp_proy.Art124 = this.rows[x].Art124;
                this.temp_proy.Ley19537 = this.rows[x].Ley19537;
                this.temp_proy.Otro = this.rows[x].Otro;
                this.temp_proy.uso_publico = this.rows[x].uso_publico;
                this.temp_proy.edif_nac = this.rows[x].edif_nac;

                console.log(this.temp_proy);
                this.dialog.open(this.openModal);

            }
        }
    }

    cleanData() {
        this.temp_proy = { destinos: '', superf_existente: '', superf_proyectada: '', npisos: '', superf_terreno: '', coef_construct: '', ocupadooc: '', proyectadooc: '', Art121: '', Art122: '', Art123: '', Art124: '', Ley19537: '', Otro: '', uso_publico: '', edif_nac: '' };

    }

    saveProyecto() {
        var id = this.temp_proy.id;
        console.log(this.temp_proy)
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                console.log("pase")
                this.rows.splice(x, 1);
                localStorage.setItem("proyecto", JSON.stringify(this.rows));

                $("#openModal").modal("hide");
                this.actualRow = localStorage.getItem("proyecto");
                this.rows = JSON.parse(this.actualRow);
                this.rows = this.rows.concat({
                    destinos: this.temp_proy.destinos,
                    superf_existente: this.temp_proy.superf_existente,
                    superf_proyectada: this.temp_proy.superf_proyectada,
                    npisos: this.temp_proy.npisos,
                    coef_construct: this.temp_proy.coef_construct,
                    ocupadoc: this.temp_proy.ocupadoc,
                    proyectadoc: this.temp_proy.proyectadoc,
                    coef_ocupacion: this.temp_proy.coef_ocupacion,
                    ocupadooc: this.temp_proy.ocupadooc,
                    proyectadooc: this.temp_proy.proyectadooc,
                    Art121: this.temp_proy.Art121,
                    Art122: this.temp_proy.Art122,
                    Art123: this.temp_proy.Art123,
                    Art124: this.temp_proy.Art124,
                    Ley19537: this.temp_proy.Ley19537,
                    Otro: this.temp_proy.Otro,
                    superf_terreno: this.temp_proy.superf_terreno,
                    uso_publico: this.temp_proy.uso_publico,
                    edif_nac: this.temp_proy.edif_nac
                })
                localStorage.setItem("proyecto", JSON.stringify(this.rows));
                this.temp_proy = [];
                this.dialog.closeAll();
            }
        }
    }

}